module.exports = __webpack_public_path__ + "img/peppol.cd80c1a3.png";